export const formatDate = (inputDate) => {
  const dt = new Date(inputDate);
  const date = dt.getDate();
  const month = dt.toLocaleString('default', { month: 'long' });
  const year = dt.getFullYear();
  let suffix = 'th';
  switch (date % 10) {
    case 1:
      suffix = 'st';
      break;
    case 2:
      suffix = 'nd';
      break;
    case 3:
      suffix = 'rd';
      break;
    default:
      suffix = 'th';
  }
  return `${date}${suffix} ${month} ${year}`;
};
